import { render, staticRenderFns } from "./SupportsEditDialog.vue?vue&type=template&id=f9e2550e&"
import script from "./SupportsEditDialog.vue?vue&type=script&lang=js&"
export * from "./SupportsEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports